module.exports = __webpack_public_path__ + "img/recurso_whatsapp.d0e7ed5c.webp";